module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot17-1200x2490.906f8714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot17-1200x2490.jpg
// module id = 1068
// module chunks = 37